import React, { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ProductContext } from "../../../store";
import DetailSkeleton from "../../../components/Skeleton/DetailSkeleton";
import ContentStudioSettingsPanel from "../../../components/AiVisibility/ContentStudio/ContentStudioSettingsPanel";
import { safeReturnTo } from "../../../components/AiVisibility/auditUtils";

export const SETTINGS_BASE = "/aivisibility/writing-assistance/settings";

const AiVisibilityContentStudioSettings = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const returnTo = safeReturnTo(searchParams.get("returnTo"));
	const { currentWebsiteId, userLoader, websiteLoader } = useContext(ProductContext);

	if (userLoader || websiteLoader) {
		return <DetailSkeleton />;
	}

	if (!currentWebsiteId) {
		return (
			<div className="contentBlock ai-visibility-dashboard">
				<p className="text-muted mb-0">Select a website to manage Content Studio settings.</p>
			</div>
		);
	}

	return (
		<div className="contentBlock ai-visibility-dashboard monitoring-page">
			<div className="monitoring">
				<div className="monitoring__page-header monitoring__page-header--stacked mb-3">
					{returnTo ? (
						<button
							type="button"
							className="monitoring__writing-toolbar-back mb-2"
							onClick={() => navigate(returnTo)}
						>
							<i className="fas fa-arrow-left me-2" aria-hidden />
							Back
						</button>
					) : null}
					<h2 className="monitoring__page-title mb-0">Settings</h2>
					<p className="monitoring__page-lead mb-0">
						Personas and brand guidelines used across Content Studio writing tools.
					</p>
				</div>
				<ContentStudioSettingsPanel websiteId={currentWebsiteId} />
			</div>
		</div>
	);
};

export default AiVisibilityContentStudioSettings;
